import { render, staticRenderFns } from "./SurveyFlow22.vue?vue&type=template&id=90bb6d84&"
import script from "./SurveyFlow22.vue?vue&type=script&lang=ts&"
export * from "./SurveyFlow22.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyFlow22.vue?vue&type=style&index=0&id=90bb6d84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports